module.exports = __webpack_public_path__ + "img/mushi.0333ba6f.png";